import React from 'react';
import CenterPanel from './centerPanel';
import RightPanel from './rightPanel';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';

export default function ContentSelfProvisionWA(props) {
  return (
    <Modal
      show={props.showWaitingAreaSelfProvisionCreateModal}
      hideWhenClickAway={false}
      className="ui modal register-user-wa"
    >
      <PopupHeader
        helpLink={APP.EXTERNAL_LINKS.WaitingArea.SelfProvisionCreate}
        title={APP.LANGUAGE.SelfProvisionCreateWA.Title}
      />

      <div className="content">
        <div className="main-ui-container  user-register-user-wa">
          <div id="righthandfloatingpanel">
            <div className="right ui rail">
              <div className="ui sticky">
                <RightPanel
                  showWaitingAreaSelfProvisionCreateModal={props.showWaitingAreaSelfProvisionCreateModal}
                  selfProvisionCreateForm={props.selfProvisionCreateForm}
                />
              </div>
            </div>
            <CenterPanel
              showWaitingAreaSelfProvisionCreateModal={props.showWaitingAreaSelfProvisionCreateModal}
              selfProvisionCreateForm={props.selfProvisionCreateForm}
            />
            <div className="bottom-rail-with-left-and-right-content mrtnull">
              <RightPanel
                showWaitingAreaSelfProvisionCreateModal={props.showWaitingAreaSelfProvisionCreateModal}
                selfProvisionCreateForm={props.selfProvisionCreateForm}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
